/**
 * Node for to-do item
 */
export class SimpleNode {
  children?: SimpleNode[];
  item: string;
  category?: string;
  collectionName?: string;
  collectionPublicName?: string;
  itemTitle?: string;
  is_med?: boolean;
  is_kinneret?: boolean;
}

/** Flat to-do item node with expandable and level information */
export class FlatNode {
  category?: string;
  collectionName?: string;
  collectionPublicName?: string;
  item: string;
  /**
   * #23 — the display label parallel to `item`, carried through the flattener so a
   * consumer can render the configured public name while `item` stays the technical
   * storage/query/request key. Absent on nodes built before this field existed and on
   * category/collection nodes, so consumers must fall back to `item`.
   */
  itemTitle?: string;
  level: number;
  expandable: boolean;
}
